import { Modal } from "antd";

interface ModalantProps {
  children: React.ReactNode;
  isOpen: boolean;
  isClose: () => void;
  className?: string;
  title?: string;
  onHandleOk?: () => void;
  isLoading?: boolean;
}
const Modalant = ({
  isOpen,
  isClose,
  onHandleOk,
  title,
  className,
  children,
  isLoading,
}: ModalantProps) => {
  return (
    <Modal
      okText={isLoading ? "Loading..." : "Subscribe"}
      className={className}
      title={title}
      open={isOpen}
      onOk={onHandleOk}
      onCancel={isClose}
      footer={onHandleOk ? undefined : null}
      keyboard={false}
      maskClosable={false}
    >
      {children}
    </Modal>
  );
};

export default Modalant;
